import { useQuoteI18n } from '../quoteI18n'

/**
 * I tre passi della prenotazione, sempre visibili una volta sbloccato il preventivo.
 *
 * Serve a rendere evidente che scegliere le offerte **non conclude** la pratica: il
 * fornitore può chiedere dati anagrafici che nessuno ha ancora, e la conferma arriva solo
 * dopo. Prima il passaggio dalla scelta al form era una schermata di successo seguita a
 * sorpresa da un modulo da compilare, che è il modo più rapido per far credere a qualcuno
 * di aver finito quando non ha finito.
 *
 * @param {Object} props
 * @param {'choosing'|'preparing'|'form'|'finalizing'|'done'} props.phase - Fase corrente
 */
export function BookingSteps({ phase }) {
  const { t } = useQuoteI18n()
  const steps = [
    { key: 'choose', label: t.steps.choose, activeIn: ['choosing'] },
    { key: 'data', label: t.steps.data, activeIn: ['preparing', 'form'] },
    { key: 'confirm', label: t.steps.confirm, activeIn: ['finalizing'] }
  ]

  const currentIndex = steps.findIndex((step) => step.activeIn.includes(phase))

  return (
    <div className="gq-steps" role="list" aria-label={t.steps.aria}>
      {steps.map((step, index) => {
        const state =
          phase === 'done' || (currentIndex !== -1 && index < currentIndex)
            ? 'done'
            : index === currentIndex
              ? 'current'
              : 'todo'

        return (
          <div className="gq-steps__item" key={step.key} data-state={state} role="listitem">
            <span className="gq-steps__bar" />
            <span className="gq-steps__label">
              {state === 'done' ? '✓ ' : ''}
              {step.label}
            </span>
          </div>
        )
      })}
    </div>
  )
}
